import { render, staticRenderFns } from "./SectionSmartPOSTLearnMore.vue?vue&type=template&id=5064b888&scoped=true"
import script from "./SectionSmartPOSTLearnMore.vue?vue&type=script&lang=ts"
export * from "./SectionSmartPOSTLearnMore.vue?vue&type=script&lang=ts"
import style0 from "./SectionSmartPOSTLearnMore.vue?vue&type=style&index=0&id=5064b888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5064b888",
  null
  
)

export default component.exports